import React from 'react';

const ComplaintDetails = ({ details, readonly }) => {
  var BASE_URL = `${endpoints[environment].api_base}/api/v1/files/download/`;
  return (
    <div className="complaint-details">
      <h5>Complaint Details</h5>
      <div className="detail-row">
        <div className="detail-label">Category of Service</div>
        <div className="detail-value">{details?.category || '-'}</div>
      </div>
      <div className="detail-row">
        <div className="detail-label">Complaint Title</div>
        <div className="detail-value">{details?.title || '-'}</div>
      </div>
      <div className="detail-row">
        <div className="detail-label">Complaint Explanation</div>
        <div className="detail-value">{details?.explanation || '-'}</div>
      </div>
      <div className="detail-row">
        <div className="detail-label">Attachment</div>
        <div className="detail-value">
          {details?.attachments?.length > 0
            ? details.attachments.map((file, idx) => {
                let disabled = readonly;
                if (disabled) return <span className='text-muted me-3'>{'Attachment ' + (idx + 1)}</span>;
                return (
                  <a
                    href={`${BASE_URL}${file}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    key={idx}
                    className="attachment-link"
                >
                  {`Attachment ${idx + 1}`}
                </a>
              );
            })
            : '-'}
        </div>
      </div>
    </div>
  );
};

export default ComplaintDetails;
